import { render } from "./JourneyPassengerSelect.vue?vue&type=template&id=071b317f&scoped=true&lang=pug"
import script from "./JourneyPassengerSelect.vue?vue&type=script&lang=ts"
export * from "./JourneyPassengerSelect.vue?vue&type=script&lang=ts"

import "./JourneyPassengerSelect.vue?vue&type=style&index=0&id=071b317f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-071b317f"

export default script